import { render, staticRenderFns } from "./SButton.vue?vue&type=template&id=39baff89&scoped=true&"
import script from "./SButton.vue?vue&type=script&lang=js&"
export * from "./SButton.vue?vue&type=script&lang=js&"
import style0 from "./SButton.vue?vue&type=style&index=0&id=39baff89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39baff89",
  null
  
)

export default component.exports